import styles from './TableAdvanced.module.scss'
import { Card } from 'react-bootstrap'
import React from 'react'
import { getLabel } from '../../../../../utils/getLabel'

interface TableAdvancedHeaderProps {
    title: string
}

export const TableAdvancedHeader = (props: TableAdvancedHeaderProps) => {
    const { title } = props

    return (
        <Card.Header className={styles.topHeader}>
            <div className="h5 py-2 m-0">{getLabel(title, undefined)}</div>
        </Card.Header>
    )
}
